import Image from 'next/image';
import { useRouter } from 'next/router';
import { Typography, Box } from '@mui/material';
import CircleRoundedIcon from '@mui/icons-material/CircleRounded';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import theme from 'src/style-system/theme';

import { AppRoutes } from '@utils/appRoutes';
import Header from '@components/Header';
import ArrowTooltips from '@components/Tooltip';
import { GetFilledChilli } from '@components/FilledChilli';

import { useStyles } from './useStyles';
import Button from '@components/Button';

interface IHeroSectionComponent {
  slice: any;
  pageType: string;
}

const HeroSectionComponent = ({ slice, pageType }: IHeroSectionComponent) => {
  const { variation, primary } = slice || {};
  const {
    type,
    dish_name,
    by_whom,
    description,
    pusblished_on,
    dish_image,
    spice_level = 0,
  } = primary || {};
  const { url, alt } = dish_image || {};

  const classes = useStyles();
  const router = useRouter();

  const SECOND_VARIATION = 'heroSectionWithTurmericBackground';

  return (
    <Box
      className={classes.mainContainer}
      bgcolor={
        variation === SECOND_VARIATION ? 'turmeric.main' : 'cinnamon.main'
      }
    >
      <Header
        isBackground={false}
        fill={
          variation === SECOND_VARIATION
            ? theme.palette.cinnamon.main
            : theme.palette.turmeric.main
        }
        TCCLogoFill={
          variation === SECOND_VARIATION
            ? theme.palette.cinnamon.main
            : theme.palette.turmeric.main
        }
      />
      <Box className={classes.container}>
        {url ? (
          <Box
            className={classes.imgWrapper}
            sx={{
              borderRadius: pageType === 'story' ? '20px' : '0px',
              overflow: pageType === 'story' ? 'hidden' : 'none',
              height: pageType === 'story' ? '240px' : '280px',
              width: pageType === 'story' ? '240px' : '280px',

              [theme.breakpoints.down('sm')]: {
                height: '200px',
                width: '200px',
              },
            }}
          >
            <Image
              src={url}
              alt={alt || dish_name}
              objectFit="cover"
              layout="fill"
            />
          </Box>
        ) : null}
        <Box className={classes.textWrapper}>
          <Box className={classes.type}>
            <Typography
              variant="body2"
              align="left"
              color={
                variation === SECOND_VARIATION
                  ? 'cinnamon.main'
                  : 'turmeric.main'
              }
            >
              {type}
            </Typography>
            <Typography
              variant="body2"
              align="left"
              color={
                variation === SECOND_VARIATION
                  ? 'cinnamon.main'
                  : 'turmeric.main'
              }
              sx={{ [theme.breakpoints.up('md')]: { display: ' none' } }}
            >
              {by_whom}
            </Typography>
          </Box>
          <Box className={classes.dishNameAndSpiceWrapper}>
            <Typography
              variant="h3"
              align="left"
              color={
                variation === SECOND_VARIATION
                  ? 'garamMasala.main'
                  : 'whitePepper.main'
              }
            >
              {dish_name}
            </Typography>
            {spice_level > 0 ? (
              <ArrowTooltips title="Spice Level">
                <>
                  {Array.from({ length: spice_level || 0 }).map((_, index) => (
                    <GetFilledChilli key={index} />
                  ))}
                </>
              </ArrowTooltips>
            ) : null}
          </Box>
          <Box className={classes.byWhomPublished}>
            <Typography
              variant="body2"
              align="left"
              color={
                variation === SECOND_VARIATION
                  ? 'cinnamon.main'
                  : 'turmeric.main'
              }
              sx={{ [theme.breakpoints.down('md')]: { display: ' none' } }}
            >
              {by_whom}
            </Typography>
            <CircleRoundedIcon
              sx={{
                color: 'garamMasala.main',
                fontSize: '10px',
                [theme.breakpoints.down('md')]: { display: ' none' },
              }}
            />
            <Typography
              variant="body2"
              align="left"
              color={
                variation === SECOND_VARIATION
                  ? 'cinnamon.main'
                  : 'turmeric.main'
              }
            >
              {pusblished_on}
            </Typography>
          </Box>
          <Typography
            variant="body1"
            color={
              variation === SECOND_VARIATION
                ? 'garamMasala.main'
                : 'whitePepper.main'
            }
            mt="30px"
            mb={{ xs: '20px', md: '30px' }}
            textAlign={{ xs: 'center', md: 'left' }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
      <Box
        className={classes.bottomContainer}
        bgcolor={
          variation === SECOND_VARIATION ? 'cinnamon.main' : 'turmeric.main'
        }
      >
        <Box sx={{ maxWidth: '1050px', margin: '0 auto' }}>
          <Box
            className={classes.backToCatalogWrapper}
            onClick={() => router.push(AppRoutes.BLOG)}
          >
            <ArrowBackIosNewIcon
              sx={{
                color:
                  variation === SECOND_VARIATION
                    ? 'whitePepper.main'
                    : 'garamMasala.main',
              }}
            />
            <Typography
              variant="body2"
              align="center"
              color={
                variation === SECOND_VARIATION
                  ? 'whitePepper.main'
                  : 'garamMasala.main'
              }
            >
              Back to Catalog
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSectionComponent;
